import {Component, EventEmitter, Input, Output} from '@angular/core';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-paginator',
	templateUrl: './paginator.component.html',
	styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {
	@Input() elementText: string;
	@Input() itemsPerPage: number;
	@Input() currentPage: number;
	@Input() totalItems: number;
	@Input() pageCount: number;

	@Output() onPreviousClickEventEmitter: EventEmitter<Event> = new EventEmitter<Event>();
	@Output() onNextClickEventEmitter: EventEmitter<Event> = new EventEmitter<Event>();
	@Output() onSelectRangeEventEmitter: EventEmitter<number> = new EventEmitter<number>();

	// claims
	@Input() showRange = true;
	@Input() showCurrent = true;

	ranges: number[] = [5, 10, 15, 20, 50];
	translateContext = TranslateContext;
}
